import { User } from './../../../../../../shared/src/lib/model/user.model';
import { ExaminationService } from './../../../../../../shared/src/lib/service/examination.service';
import { ExaminationSessionService } from './../../../../../../shared/src/lib/service/examination-session.service';
import { ExaminationSession } from './../../../../../../shared/src/lib/model/examination-session.model';
import { takeUntil, Subject, debounceTime } from 'rxjs';
import { AppStateManage } from 'src/app/manage.states';
import { Store } from '@ngrx/store';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { FormGroup, FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { FiltersService } from '../../../../../../shared/src/lib/service/filters.service';
import { MatPaginator } from '@angular/material/paginator';
import moment from 'moment';


@Component({
  selector: 'app-examination-session-list',
  templateUrl: './examination-session-list.component.html',
  styleUrls: ['./examination-session-list.component.scss']
})
export class ExaminationSessionListComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  examinationsSessions: ExaminationSession[];
  user: User

  resultsLength: number = 0;
  page_size: number = 20;
  loading: boolean;

  examinationsSessionsDataSource: MatTableDataSource<ExaminationSession> = new MatTableDataSource();
  examinationsSessionsTableColumns: string[] = ['id', 'student', 'teacher', 'modality', 'date', 'open'];

  filterFormGroup = new FormGroup({
    id: new FormControl(),
    student: new FormControl(),
    teacher: new FormControl(),
  });

  next: string = null;
  prev: string = null;

  constructor(
    private store: Store<AppStateManage>,
    private examinationSessionService: ExaminationSessionService,
    private examinationService: ExaminationService,
    private filterService: FiltersService
  ) { }

  ngAfterViewInit(): void {
    this.store.pipe(takeUntil(this._unsubscribeAll)).subscribe(store => {
      this.user = store.user.me.user
    });

    if (localStorage.getItem('filtersExaminationSessions')) {
      const local = JSON.parse(localStorage.getItem('filtersExaminationSessions'));
      Object.keys(this.filterFormGroup.controls).forEach(key => {
        if (local[key]) {
          this.filterFormGroup.get(key).setValue(local[key]);
        }
      });
    }

    this.filterFormGroup.valueChanges.pipe(debounceTime(1000)).subscribe(
      () => {
        localStorage.setItem('filtersExaminationSessions', JSON.stringify(this.filterFormGroup.value));
        this.getExaminationSessions();
      }
    )

    this.paginator.page.pipe(
      takeUntil(this._unsubscribeAll),
      debounceTime(500),
    ).subscribe(
      event => {
        if (event.previousPageIndex > event.pageIndex) {
          if (this.prev) {
            this.examinationSessionService.getExaminationSessionsByUrl(this.prev)
              .pipe(takeUntil(this._unsubscribeAll))
              .subscribe(data => {
                this.examinationsSessions = data.results
                this.examinationsSessionsDataSource = data.results ? new MatTableDataSource(data.results) : new MatTableDataSource();
                this.resultsLength = data ? data.count : 0;
                this.next = data ? data.next : null;
                this.prev = data ? data.previous : null;
              })
          }
        } else if (event.previousPageIndex === event.pageIndex) {
          localStorage.setItem('filtersExaminationSessions', JSON.stringify(this.filterFormGroup.value));
          this.getExaminationSessions();
        } else {
          if (this.next) {
            this.examinationSessionService.getExaminationSessionsByUrl(this.next)
              .pipe(takeUntil(this._unsubscribeAll))
              .subscribe(data => {
                this.examinationsSessions = data.results
                this.examinationsSessionsDataSource = data.results ? new MatTableDataSource(data.results) : new MatTableDataSource();
                this.resultsLength = data ? data.count : 0;
                this.next = data ? data.next : null;
                this.prev = data ? data.previous : null;
              })
          }
        }
      }
    )


    this.getExaminationSessions()
  }

  openSession(examinationSession: ExaminationSession) {
    this.examinationService.openSession(this.user.email, examinationSession.lilate.id, localStorage.getItem('access_token'), '_blank');
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  getExaminationSessions(): void {
    let params = new HttpParams();

    params = params.set('page_size', this.paginator.pageSize.toString());
    params = params.set('status__in', 'pending,ongoing,pending_assessment');
    params = params.set('lilate__status', 'booked');
    params = params.set('ordering', 'lilate__start');
    params = params.set('start_date', moment().format('YYYY-MM-DD'));
    params = this.formatFilter(params);
    params.keys()
    this.examinationSessionService.getExaminationSessions(params).subscribe(data => {
      this.examinationsSessionsDataSource = data.results ? new MatTableDataSource(data.results) : new MatTableDataSource();
      this.resultsLength = data ? data.count : 0;
      this.next = data ? data.next : null;
      this.prev = data ? data.previous : null;
    })
  }

  formatFilter(params: HttpParams) {
    params = this.filterService.formatText(this.filterFormGroup, 'id', params, 'lilate__id')
    params = this.filterService.formatText(this.filterFormGroup, 'student', params, 'student_name')
    params = this.filterService.formatText(this.filterFormGroup, 'teacher', params, 'teachers_name')
    return params;
  }

  clearFilter() {
    this.filterFormGroup.reset();
    localStorage.removeItem('filtersExaminationSessions')
  }
}
